var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("router-link", { attrs: { to: { name: "systemslist" } } }, [
        _vm._v("<<Back to Infrastructure List"),
      ]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c("v-flex", [
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.system.type
                    ? _vm.system.type.description
                    : _vm.system.code
                ) +
                  ": " +
                  _vm._s(_vm.system.name)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              !!_vm.system.id
                ? _c("v-switch", {
                    attrs: {
                      inset: "",
                      "input-value": _vm.system.pollEnabled,
                      loading: _vm.enabling,
                      disabled: _vm.enabling,
                      label: _vm.enabledLabel(),
                      "hide-details": "",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleEnabled(_vm.system)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            { attrs: { "ma-2": "", "pa-2": "" } },
            [
              _vm.appSection
                ? _c("system-data-entry-section", {
                    attrs: {
                      system: _vm.system,
                      section: _vm.appSection,
                      display: true,
                      displaySystemInfo: true,
                      userIsSU: _vm.isSU,
                      userIsSUPro: _vm.isSUPro,
                      sections: _vm.sections,
                      sectionIdChanged: _vm.sectionIdChanged,
                    },
                    on: {
                      systemdirty: _vm.systemdirty,
                      sectionPropChanged: _vm.sectionPropChanged,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.nonAppSections, function (section) {
        return _c(
          "v-layout",
          { key: section.id },
          [
            _vm.showSection(section)
              ? _c(
                  "v-flex",
                  { attrs: { "ma-2": "", "pa-2": "" } },
                  [
                    _c("system-data-entry-section", {
                      attrs: {
                        system: _vm.system,
                        section: section,
                        sections: _vm.allSections,
                        userIsSU: _vm.isSU,
                        userIsSUPro: _vm.isSUPro,
                        sectionIdChanged: _vm.sectionIdChanged,
                      },
                      on: {
                        systemdirty: _vm.systemdirty,
                        sectionPropChanged: _vm.sectionPropChanged,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.orgLevelSections
        ? _c(
            "v-layout",
            _vm._l(_vm.orgLevelSections, function (section) {
              return _c(
                "v-layout",
                { key: section.id },
                [
                  _vm.showSection(section)
                    ? _c(
                        "v-flex",
                        { attrs: { "ma-2": "", "pa-2": "" } },
                        [
                          _c("system-data-entry-section", {
                            attrs: {
                              section: section,
                              sections: _vm.allSections,
                              orgLevel: true,
                              userIsSU: _vm.isSU,
                              userIsSUPro: _vm.isSUPro,
                              sectionIdChanged: _vm.sectionIdChanged,
                            },
                            on: { sectionPropChanged: _vm.sectionPropChanged },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showSchedules()
        ? _c(
            "v-layout",
            { attrs: { "ma-2": "", "pa-2": "" } },
            [
              _c(
                "v-flex",
                [
                  _c("system-schedules", {
                    attrs: {
                      system: _vm.system,
                      schedules: _vm.schedules,
                      disableInterval: !_vm.isSUPro,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.system.id && (_vm.isSU || _vm.isSUPro)
        ? _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { xs6: "", "ml-4": "" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.getCollectionAgents(_vm.system),
                      label: "Collection Agents",
                      "item-text": "login",
                      "item-value": "id",
                    },
                    model: {
                      value: _vm.system.ccaId,
                      callback: function ($$v) {
                        _vm.$set(_vm.system, "ccaId", $$v)
                      },
                      expression: "system.ccaId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs1: "", "mt-3": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", small: "" },
                      on: { click: _vm.saveCcaId },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs1: "", "mt-3": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", small: "" },
                      on: { click: _vm.resetCcaId },
                    },
                    [_vm._v("Reset")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "300" },
          model: {
            value: _vm.enabling,
            callback: function ($$v) {
              _vm.enabling = $$v
            },
            expression: "enabling",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { color: "primary", dark: "" } },
            [
              _c(
                "v-card-text",
                [
                  _vm._v("\n                Please stand by\n                "),
                  _c("v-progress-linear", {
                    staticClass: "mb-0",
                    attrs: { indeterminate: "", color: "white" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }